import React, {Component} from "react";
import classNames from "classnames";

import Layout from "./LayoutView";
import {ConfigService} from "../../service/config/ConfigService";

export default class LayoutContainer extends Component {
    constructor(props) {
        super(props);

        this.configService = new ConfigService();

        this.state = {
            version: '',
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.getBusinessVersion = this.getBusinessVersion.bind(this);

        this.createMenu();
    }

    componentDidMount() {
        this.getBusinessVersion();
    }

    getBusinessVersion() {
        this.setState({
            version: this.configService.getBusinessVersion(),
        });
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            } else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        } else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        let json = localStorage.getItem("menu");

        this.menu = JSON.parse(json);
    }

    render() {
        let wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });
        let sidebarClassName = classNames("layout-sidebar", {'layout-sidebar-dark': this.state.layoutColorMode === 'dark'});

        return (
            <Layout
                wrapperClass={wrapperClass}
                sidebarClassName={sidebarClassName}
                onWrapperClick={this.onWrapperClick}
                onSidebarClick={this.onSidebarClick}
                onMenuItemClick={this.onMenuItemClick}
                onToggleMenu={this.onToggleMenu}
                menu={this.menu}
                layoutMenuScroller={this.layoutMenuScroller}
                sidebar={this.sidebar}
                history={this.props.history}
                version={this.state.version}
            />
        );
    }
};